var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsLoginParents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.68 1.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BDD9FF",
    x: 17.73,
    width: 28.743,
    height: 29.481,
    rx: 14.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.476 31.206c13.847-1.996 27.03 6.574 30.827 20.04l6.045 21.437a4.643 4.643 0 0 1-3.806 5.856l-52.058 7.504a4.643 4.643 0 0 1-5.305-4.606l.049-22.3C7.259 45.1 17.582 33.21 31.476 31.208z",
    fill: "#EEF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.186 85.495h19.892a4.643 4.643 0 0 1 4.619 5.117L46.9 137.34a4.643 4.643 0 0 1-4.619 4.17h-10.3c-2.382 0-4.377-1.801-4.62-4.17l-4.795-46.728a4.643 4.643 0 0 1 4.619-5.117z",
    fill: "#BDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.483 54.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BDD9FF",
    x: 20.204,
    width: 25.726,
    height: 26.384,
    rx: 12.863
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.48 60.878 4.854.874a21.308 21.308 0 0 0 23.49-12.891l4.851-11.837a3.589 3.589 0 0 0-2.685-4.892L10.308 24.09a3.589 3.589 0 0 0-4.22 3.698l.588 12.767A21.663 21.663 0 0 0 24.48 60.878z",
    fill: "#EEF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.617 63.028h12.269a4.606 4.606 0 0 1 4.56 5.248l-2.314 16.44a4.606 4.606 0 0 1-4.56 3.963H25.93a4.606 4.606 0 0 1-4.56-3.963l-2.315-16.44a4.606 4.606 0 0 1 4.56-5.248z",
    fill: "#BDD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLoginParents);
export default __webpack_public_path__ + "static/media/icons_login_parents.477900d85c1edc5f827136e6aaf0ad36.svg";
export { ForwardRef as ReactComponent };